import {createSelector} from "@reduxjs/toolkit";

import {RootState} from "./store";

const selectProfile = (select: RootState) => select.profile;
const selectMaterials = (select: RootState) => select.materials;
const selectScreening = (select: RootState) => select.screening;
const selectScreeningEarly = (select: RootState) => select.screeningEarly;
const selectArticles = (select: RootState) => select.articles;

export const selectStore = createSelector(
  selectProfile,
  selectMaterials,
  selectScreening,
  selectScreeningEarly,
  selectArticles,
  (
    profile,
    materials,
    screening,
    screeningEarly,
    articles,
  ) => ({
    profile,
    materials,
    screening,
    screeningEarly,
    articles,
  }));